import { TripDetail, DispatchItemsDto } from '../../../../../core';

export const TripDeliver = {
  expandable: true,
  isButtonDisabled: true,
  paginatorAllData: true,
  columns: [
    {
      title: 'N° Desp',
      name: 'dispatchId',
      type: 'string',
      visible: true,
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: TripDetail) => element.dispatchId
    },
    {
      title: 'Cant. Solicitada',
      name: 'requestAmount',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: TripDetail) => element.requestAmount
    },
    {
      title: 'Cant. Entregada',
      name: 'deliveredQuantity',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: TripDetail) => element.deliveredQuantity
    },
    {
      title: 'Cant. Pendiente',
      name: 'deliveredPending',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: TripDetail) => (element.requestAmount - element.deliveredQuantity).toFixed(3)
    },
    {
      title: 'Estado',
      name: 'deliveryTripState',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: TripDetail) => element.deliveryTripState
    }
  ]
};

export const DetailTripDeliver = {
  classValidation: (row: any) => {
    if (row.state === 'Entregado') {
      return 'success';
    }
    return '';
  },
  hasDisabledInput: (element: DispatchItemsDto): boolean => {
    return !element.processedAmount && element.state === 'Entregado'
  },
  show: 'No hay información para mostrar',
  columns: [
    {
      title: 'SKU',
      name: 'skuCode',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchItemsDto) => element.skuCode
    },
    {
      title: 'Descripción',
      name: 'skuName',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchItemsDto) => element.skuName
    },
    {
      title: 'Cantidad total',
      name: 'currentAmount',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: DispatchItemsDto) => (element.currentAmount != null) ? element.currentAmount : 0
    },
    {
      title: 'Cantidad entregada',
      name: 'pendingAmount',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: DispatchItemsDto) => (element.pendingAmount != null) ? element.deliveredQuantity : 0
    },
    {
      title: 'Cantidad a entregar',
      name: 'processedAmount',
      type: 'number',
      editable: true,
      class: 'center',
      value: (element: DispatchItemsDto) => {
        return { num: element.processedAmount, min: 1, max: element.pendingAmount }
      }
    },
    {
      title: 'Estado',
      name: 'state',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchItemsDto) => element.state
    }
  ]
};
